import styled from 'styled-components';
import { filterToValidAttributes } from '@zocdoc/dom-property';
import React from 'react';

import { Icon } from './_base';
import { grey75 } from '@zocdoc/branding/colors';

const DotSVG = styled(Icon).attrs({ viewBox: '0 0 7 6' })`
    width: 1.1666666667em;
`;

const Dot = ({ color = grey75, ...props }) => (
    <DotSVG
        data-test="icon-dot"
        {...filterToValidAttributes(props)}
    >
        <ellipse
            cx="3"
            cy="3"
            fill={color}
            rx="3"
            ry="3"
        />
    </DotSVG>
);

export {
    Dot as default,
    Dot,
};
